import { render, staticRenderFns } from "./BtnAtualizarProcesso.vue?vue&type=template&id=710daf3e&"
import script from "./BtnAtualizarProcesso.vue?vue&type=script&lang=js&"
export * from "./BtnAtualizarProcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports